export class TemplateMedicineGroupRequest{
    public idMedicineType: number;
    public medicineGroupName: string;
    public medicineGroupDescription: string;
}